import React from 'react';
import { MagnifyGlass } from '../../../../../../static/icons/iconMagnifyingglass';
import { Typography } from '../../../../atoms/typography/Typography';
import { LinkButton } from '../../../../atoms/linkButton/LinkButton';
import { StyledSearchText } from '../searchInput/SearchInput';

const SearchInputMobile = ({
  handleInputChange,
  onBlur,
  results,
  query,
  t,
}) => (
  <div className="relative flex items-center w-full flex-col" onBlur={onBlur}>
    <div className="absolute right-4 h-full flex items-center">
      <MagnifyGlass color="black" />
    </div>
    <input
      onChange={handleInputChange}
      value={query}
      className={`pl-4 pr-10 w-full py-2 border
          border-black placeholder-black text-black
     focus:placeholder-opacity-60 rounded-full bg-transparent focus:outline-none`}
      placeholder={t('common.search')}
    />
    <div
      className={`absolute top-12 w-full flex flex-col ${
        query.length > 0 ? 'flex' : 'hidden'
      }`}
    >
      {results.length > 0 ? (
        results.map((result, i) => (
          <LinkButton
            key={i}
            className="text-sm w-full font-medium text-customGray-900"
            variant="transparent"
            textAlign="left"
            label={`${result.text} -> ${
              result.strongName ? <strong>{result.name}</strong> : result.name
            }`}
            title={result.name}
            href={result.url}
          >
            <StyledSearchText className="relative max-sm:max-w-[140px] pr-3 whitespace-nowrap text-ellipsis text-customGray-600 overflow-hidden">
              {result.text}
            </StyledSearchText>
            {result.strongName ? <strong>{result.name}</strong> : result.name}
          </LinkButton>
        ))
      ) : (
        <Typography
          fontVariant="lg"
          textAlign="left"
          className="!text-customGray-500 ml-4 py-2"
        >
          {t('common.noResults')}
        </Typography>
      )}
    </div>
  </div>
);

export default SearchInputMobile;
